import * as THREE from 'three';

import {
  getHorizontalRotationBetweenPoints,
  getVerticalRotationBetweenPoints,
} from '@/utils/three/getHorizontalRotationBetweenPoints';

export const rotateCameraToObject = async ({ showCaseTemp, currentPoint, nextPoint }) => {
  const pos1 = new THREE.Vector3(
    currentPoint.data.position.x,
    currentPoint.data.position.y,
    currentPoint.data.position.z,
  );
  const pos2 = new THREE.Vector3(
    nextPoint.data.position.x,
    nextPoint.data.position.y,
    nextPoint.data.position.z,
  );
  const yawDegrees = getHorizontalRotationBetweenPoints(pos1, pos2);
  const pitchDegrees = getVerticalRotationBetweenPoints(pos1, pos2); //* 0.75;
  await showCaseTemp.showcase.Camera.setRotation({ x: pitchDegrees, y: yawDegrees }, 75);
};
